export function formatHtml(text: string | HTMLElement): string {
  return `<span style="font-size: 1.4rem">${text}</span>`;
}

export const defaultSwalTimer = (): number => {
  return 2500;
};

export const defaultSwalWidth = (): string => {
  return '30vw';
};
